(function () {
  function initCommunityVideos(root) {
    const scope = root instanceof Element ? root : document;
    const videos = scope.querySelectorAll(
      '[data-eg-community-video]:not([data-eg-community-video-ready="true"])'
    );

    videos.forEach((video) => {
      const playButton = video.querySelector('[data-eg-community-video-play]');
      const thumbnail = video.querySelector('[data-eg-community-video-thumbnail]');
      const frame = video.querySelector('[data-eg-community-video-frame]');

      video.dataset.egCommunityVideoReady = 'true';

      if (!playButton || !thumbnail || !frame || !frame.dataset.src) {
        return;
      }

      playButton.addEventListener('click', () => {
        frame.src = frame.dataset.src;
        frame.hidden = false;
        thumbnail.hidden = true;
      }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCommunityVideos(document), { once: true });
  } else {
    initCommunityVideos(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCommunityVideos(event.target);
  });
})();
